/**
 * One judge tap as it lands in Firestore: the audit entry at
 * `competitions/{compId}/attempts/{uid}_{routeId}/audit/{eventId}` that the durable
 * queue (./judgeQueue.js) flushes. The aggregate `attempts/{id}` document is never
 * written next to it — the `recomputeAttemptFromAudit` Cloud Function rebuilds it
 * from these entries.
 *
 * Pure and firebase-free, so the E2E seed (tests/e2e/seed/competitions.js) records a
 * judged result the way a judge's device does, and the trigger does the rest.
 *
 * The caller owns `createdAt` (an SDK sentinel) and, on a delegated flush (judge A
 * tapped offline, judge B's login uploads it), `delegatedFlushBy` = the uploader.
 *
 * @param {{ type: "fall"|"zone"|"top", actorUid: string, actorRole?: string, uid: string,
 *   routeId: string, groupId?: string, sessionId?: string, compId: string,
 *   snapshot?: object|null, tappedAt?: number|null }} p  the queued event's payload
 * @param {{ createdAt: unknown, delegatedFlushBy?: string|null }} stamps
 */
export function buildJudgeEventAudit(p, { createdAt, delegatedFlushBy = null }) {
  return {
    type: p.type,
    actorUid: p.actorUid,
    actorRole: p.actorRole || "judge",
    createdAt,
    uid: p.uid,
    routeId: p.routeId,
    groupId: p.groupId || "",
    sessionId: p.sessionId || "",
    compId: p.compId,
    snapshot: p.snapshot || null,
    tappedAt: p.tappedAt || null,
    ...(delegatedFlushBy ? { delegatedFlushBy } : {}),
  };
}
